@use "../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../styles/Constants.scss" as Constants;

.time-sheet-info {

	&__user-name {
		color: Colors.$col-greyDark;
		font-size: Constants.$val-fontSizeXBig;
		font-weight: bold;
		text-transform: uppercase;
		display: flex;
		flex-direction: row;
		margin-bottom: Constants.$val-spacing-xs;
		padding-top: Constants.$val-spacing-xs;
	
		&__warning-icon {
			margin-right: Constants.$val-spacing-s;
			color: Colors.$col-grey;
			cursor: pointer;
	
			&--not-approved {
				color: Colors.$col-canceledRed;
			}
		}
	
		&--owner {
			color: Colors.$col-blue;
		}

		&--warning {
			color: Colors.$col-design-red600;
		}
	}
	
	&__temporary-employee-icon {
		margin-right: Constants.$val-spacing-xs;
		font-size: Constants.$val-fontSizeXXBig;
	}
	
	&__uniqueId {
		font-size: Constants.$val-fontSizeSmall;
		color: gray;
		display: flex;
		flex-direction: column-reverse;
		margin-bottom: Constants.$val-spacing-xs;
	}

	&__per-diem {
		font-size: Constants.$val-fontSizeRegular;
		margin-top: auto;
		margin-bottom: auto;
		margin-left: Constants.$val-spacing-m;
		font-weight: normal;

		&__text{
			color: Colors.$color-green;
			font-weight: bold;
			margin-right: Constants.$val-spacing-xs;
		}
	}
}

.time-sheet-signature {
	width: 214px;

	&__section {
		$var-borderRadius: 2px;
		$var-imageHeight: 40px;
		$var-imageMaxWidth: 72px;
	
		color: Colors.$col-greyDark;
		font-size: Constants.$val-fontSizeSmall;
		font-weight: normal;
	
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 12px;
	
		&+& {
			margin-top: Constants.$val-spacing-m;
		}
	
		&__superintendent {
			color: Colors.$col-red;
			margin: Constants.$val-spacing-s 0;
		}
	
		&__date {
			margin-left: Constants.$val-spacing-xs;
	
			&--block {
				display: block;
			}
		}
	
		&__name {
			margin-left: Constants.$val-spacing-xs;
		}
	
		&__image {
			margin-top: Constants.$val-spacing-s;
			height: $var-imageHeight;
			max-width: $var-imageMaxWidth;
		}
	
		&--inline {
			display: flex;
			margin-bottom: Constants.$val-spacing-m;
	
			.text-red {
				margin-left: Constants.$val-spacing-m;
			}
		}

		&__placeholder {
			margin-top: Constants.$val-spacing-s;
			height: $var-imageHeight;
			min-width: $var-imageMaxWidth;
		}
	}
}

